import React, { createContext, useState, ReactNode, useContext } from 'react';

interface ReportContextType {
    reportEditMode: boolean;
    toggleEditMode: () => void;
    toggleNotesDialog: () => void;
    toggleFooterDialog: () => void;
    updateColorStyle: (color: string) => void;
    colorStyle: string;
    footerDialogOpen: boolean;
    notesDialogOpen: boolean;
}


const ReportContext = createContext<ReportContextType | undefined>(undefined);

export const useReport = (): ReportContextType => {
    const context = useContext(ReportContext);
    if (!context) {
        throw new Error('useReport must be used within a ReportProvider');
    }
    return context;
};


interface ReportProviderProps {
    children: ReactNode;
}

export const ReportProvider: React.FC<ReportProviderProps> = ({ children }) => {
    const [reportEditMode, setReportEditMode] = useState<boolean>(false);
    const [notesDialogOpen, setNotesDialogOpen] = useState<boolean>(false);
    const [colorStyle, setColorStyle] = useState<string>('red');
    const [footerDialogOpen, setFooterDialogOpen] = useState<boolean>(false);
    const [logo, setLogo] = useState<string>('');
    

    const toggleNotesDialog = () => {
        setNotesDialogOpen(prev => !prev);
    };

    const toggleEditMode = () => {
        setReportEditMode(prev => !prev);
    };


    const toggleFooterDialog = () => {
        setFooterDialogOpen(prev => !prev);
    };

    const updateColorStyle = (color: string) => {
        setColorStyle(color);
    }

    return (
        <ReportContext.Provider value={{ toggleNotesDialog, notesDialogOpen, updateColorStyle, reportEditMode, colorStyle, footerDialogOpen, toggleFooterDialog, toggleEditMode }}>
            {children}
        </ReportContext.Provider>
    );
};